import React, { Fragment, useState, useEffect } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getSubscriptions } from "../../../actions/subscribe";
import { setAlert } from "../../../actions/alert";

import BlueLogo from "../Employers/BlueLogo";
import BlueSpinner from "../../../img/Blue_Spinner.gif";
import Alert from "./Alert";

const CardField = ({ onChange }) => (
  <div className="FormRow">
    <CardElement
      className="sub-input"
      onChange={onChange}
      options={CARD_OPTIONS}
    />
  </div>
);

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#FFF",
      color: "#fff",
      fontWeight: 500,
      fontFamily: "Krub, sans-serif",
      fontSize: "14px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883",
      },
      "::placeholder": {
        color: "#FFF",
      },
    },
    invalid: {
      iconColor: "#ffc7ee",
      color: "#ffc7ee",
    },
  },
};

const Field = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const SubmitButton = ({ processing, error, children, disabled }) => (
  <button
    className={`purchase-sub background-blue bold ${
      error ? "SubmitButton--error" : ""
    }`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? "Processing..." : children}
  </button>
);

const ErrorMessage = ({ children }) => (
  <div className="ErrorMessage white" role="alert">
    <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
      />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
      />
    </svg>
    {children}
  </div>
);

const SubscribeIMEEmployer = ({
  match,
  user: { channelid, role, avatar, firstname, lastname, companyname, location },
  subscribe: { subscriptions },
  setSelectedPlan,
  selectedPlan,
  setShowEmployerSubscription,
  getSubscriptions,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [billingDetails, setBillingDetails] = useState({
    name: "",
    email: "",
    address: {
      country: "US",
      city: "",
      line1: "",
      line2: "",
      state: "Alabama",
    },
  });
  const [paymentDetails, setPaymentDetails] = useState({
    status: "",
    receipt_email: "",
  });
  const [showPayment, setshowPayment] = useState(true);
  const [redirect, setRedirect] = useState(false);
  const [isCheckedAutoRenew, setIsCheckedAutoRenew] = useState(true);

  useEffect(() => {
    getSubscriptions(match.params.channelid);
  }, [getSubscriptions, match.params.channelid]);

  const foundSubscription = subscriptions.map(
    (subscription) => subscription.type === "Employer"
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (billingDetails.name === "") {
      setAlert("Please enter a name");
    }

    if (billingDetails.email === "") {
      setAlert("Please enter a valid email");
    }

    if (billingDetails.address.line1 === "") {
      setAlert("Please enter your street address");
    }

    if (billingDetails.address.city === "") {
      setAlert("Please enter a city");
    }

    if (billingDetails.address.state === "") {
      setAlert("Please enter a state");
    }

    if (billingDetails.address.country === "") {
      setAlert("Please enter a country");
    }

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: billingDetails,
    });

    setProcessing(false);

    if (error) {
      setError(error);
    } else {
      setPaymentMethod(paymentMethod);
    }

    try {
      const { id } = paymentMethod;
      const res = await axios.post(
        "http://localhost:5000/employer_subscription_payment",
        {
          amount: selectedPlan.price,
          id,
          isCheckedAutoRenew,
          billingDetails,
          selectedPlan,
        }
      );

      setPaymentDetails({
        status: res.data.status,
        receipt_email: res.data.receipt_email,
      });
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleResubscribe = async (e) => {
    e.preventDefault();

    if (billingDetails.name === "") {
      setAlert("Please enter a name");
    }

    if (billingDetails.email === "") {
      setAlert("Please enter a valid email");
    }

    if (billingDetails.address.line1 === "") {
      setAlert("Please enter your street address");
    }

    if (billingDetails.address.city === "") {
      setAlert("Please enter a city");
    }

    if (billingDetails.address.state === "") {
      setAlert("Please enter a state");
    }

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: billingDetails,
    });

    setProcessing(false);

    if (error) {
      setError(error);
    } else {
      setPaymentMethod(paymentMethod);
    }

    try {
      const { id } = paymentMethod;
      const res = await axios.post(
        "http://localhost:5000/employer_subscription_resubscribe",
        {
          amount: selectedPlan.price,
          id,
          isCheckedAutoRenew,
          billingDetails,
          selectedPlan,
        }
      );

      setPaymentDetails({
        status: res.data.status,
        receipt_email: res.data.receipt_email,
      });
    } catch (error) {
      console.log("Error", error);
    }
  };

  if (redirect) {
    return <Redirect to={`/${channelid && channelid}`} />;
  }

  return (
    <Fragment>
      {paymentDetails.status === "active" && showPayment && (
        <div className="subscription-overlay">
          <div className="subscription-box-confirmation">
            <i
              className="far fa-times-circle blue fa-3x subscription-x"
              onClick={() => {
                setshowPayment(false);
                setRedirect(true);
              }}
            ></i>
            <div className="subscription-type-container">
              <p className="nav-logo">
                <BlueLogo />
              </p>
              <h1 className="subscription-name blue">Payment Successful!</h1>
            </div>
            <div className="sub-grid-three">
              <div className="sub-container">
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt blue">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                        className="sub-avi"
                        alt="avatar"
                      />
                    </div>
                  </div>
                  <div className="online-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="blue name-font bold">
                          {firstname} {lastname}
                        </span>
                      </li>
                      <li className="user-online-item">{companyname}</li>
                      <li className="user-online-item">
                        {location.city}, {location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-grid">
              <p className="user-request-text">
                Thank you for your payment! Your recurring monthly subscription
                to{" "}
                <span className="blue bold mx-5">
                  ime's{" "}
                  {selectedPlan.silver
                    ? "Silver"
                    : selectedPlan.gold
                    ? "Gold"
                    : selectedPlan.platinum
                    ? "Platinum"
                    : ""}{" "}
                  Employer Package
                </span>
                is confirmed.
              </p>
            </div>
          </div>
        </div>
      )}
      {paymentDetails.status === "succeeded" && showPayment && (
        <div className="subscription-overlay">
          <div className="subscription-box-confirmation">
            <i
              className="far fa-times-circle blue fa-3x subscription-x"
              onClick={() => {
                setshowPayment(false);
                setRedirect(true);
              }}
            ></i>
            <div className="subscription-type-container">
              <p className="nav-logo">
                <BlueLogo />
              </p>
              <h1 className="subscription-name blue">Payment Successful!</h1>
            </div>
            <div className="sub-grid-three">
              <div className="sub-container">
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt blue">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                        className="sub-avi"
                        alt="blue-avatar"
                      />
                    </div>
                  </div>
                  <div className="online-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="blue name-font bold">
                          {firstname} {lastname}
                        </span>
                      </li>
                      <li className="user-online-item">{companyname}</li>
                      <li className="user-online-item">
                        {location.city}, {location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="sub-container">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <p className="sub-section blue">Payment Amount</p>
                  </div>
                </div>
                <div className="subtotal">
                  <p className="total-price white">
                    {selectedPlan.silver
                      ? "$100.00"
                      : selectedPlan.gold
                      ? "$300.00"
                      : selectedPlan.platinum
                      ? "$500.00"
                      : "No amount found"}
                  </p>
                </div>
              </div>
            </div>
            <div className="sub-grid">
              <p className="user-request-text">
                Thank you for your payment! A receipt has been emailed to the
                following email address:{" "}
                <span className="blue bold">
                  {paymentDetails.receipt_email}
                </span>
                . Your 1 month subscription to{" "}
                <span className="blue bold mx-5">
                  ime's{" "}
                  {selectedPlan.silver
                    ? "Silver"
                    : selectedPlan.gold
                    ? "Gold"
                    : selectedPlan.platinum
                    ? "Platinum"
                    : ""}{" "}
                  Employer Package
                </span>
                is confirmed.
              </p>
            </div>
          </div>
        </div>
      )}
      {!paymentMethod && (
        <div className="subscription-overlay">
          {role === "employer" && (
            <div className="subscription-box">
              {processing && (
                <div className="spinner-overlay">
                  <img src={BlueSpinner} alt="spinner-position" />
                </div>
              )}
              <i
                className="far fa-times-circle blue fa-3x subscription-x"
                onClick={() => setShowEmployerSubscription(false)}
              ></i>
              <div className="subscription-type-container">
                <p className="nav-logo">
                  <BlueLogo />
                </p>
                <h1 className="subscription-name blue">
                  Subscription to ime Employer Packages
                </h1>
              </div>
              <form
                method="POST"
                className="subscription-box-container"
                id="blue-scroll"
                onSubmit={(e) =>
                  foundSubscription && foundSubscription.length > 0
                    ? handleResubscribe(e)
                    : handleSubmit(e)
                }
              >
                <div className="sub-grid-three">
                  <div className="sub-container">
                    <div className="sub-user">
                      <div className="online-avi-container">
                        <div className="avi-color-border-alt blue">
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/employers/Innovate_Me_logo_blue.png`}
                            className="sub-avi"
                            alt="sub-avatar"
                          />
                        </div>
                      </div>
                      <div className="online-info">
                        <ul className="user-online-items">
                          <li className="user-online-item">
                            <span className="blue name-font bold">ime</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {!selectedPlan.silver &&
                    !selectedPlan.gold &&
                    !selectedPlan.platinum && (
                      <div className="sub-container">
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <p className="sub-section blue">Subtotal</p>
                          </div>
                        </div>
                        <div className="subtotal">
                          <p className="total-price white">$0.00</p>
                        </div>
                      </div>
                    )}
                  {selectedPlan.silver && (
                    <div className="sub-container">
                      <div className="sub-section-container">
                        <div className="flex-only">
                          <p className="sub-section blue">Subtotal</p>
                        </div>
                      </div>
                      <div className="subtotal">
                        <p className="total-price white">$100.00</p>
                      </div>
                    </div>
                  )}
                  {selectedPlan.gold && (
                    <div className="sub-container">
                      <div className="sub-section-container">
                        <div className="flex-only">
                          <p className="sub-section blue">Subtotal</p>
                        </div>
                      </div>
                      <div className="subtotal">
                        <p className="total-price white">$300.00</p>
                      </div>
                    </div>
                  )}
                  {selectedPlan.platinum && (
                    <div className="sub-container">
                      <div className="sub-section-container">
                        <div className="flex-only">
                          <p className="sub-section blue">Subtotal</p>
                        </div>
                      </div>
                      <div className="subtotal">
                        <p className="total-price white">$500.00</p>
                      </div>
                    </div>
                  )}
                </div>
                {selectedPlan.price !== 0 && (
                  <div
                    className="select-plan blue bold"
                    onClick={() =>
                      setSelectedPlan({
                        price: 0,
                        silver: false,
                        gold: false,
                        platinum: false,
                      })
                    }
                  >
                    Select a different plan
                  </div>
                )}
                {!selectedPlan.silver &&
                  !selectedPlan.gold &&
                  !selectedPlan.platinum && (
                    <div>
                      <div className="sub-section-container">
                        <div className="flex-only">
                          <i className="fas fa-medal mr-5 fa-lg mt-5 blue"></i>
                          <p className="sub-section blue">ime Silver Package</p>
                        </div>
                      </div>
                      <div
                        className="gift-subs"
                        price={10000}
                        onClick={(e) =>
                          setSelectedPlan({
                            silver: true,
                            gold: false,
                            platinum: false,
                            price: e.currentTarget.attributes.price.value,
                          })
                        }
                      >
                        <div className="job-posts-count white bold">1</div>
                        <div className="gift-subs-description">
                          <div className="gift-subs-icon-text bold">
                            ime Silver Package
                            <i className="fas fa-box-open mx-10 fa-lg align-icon blue"></i>
                          </div>
                        </div>
                        <div className="gift-subs-price blue">
                          <div className="gift-subs-icon-text-center bold">
                            $100
                            <i className="fas fa-ranking-star mx-10 fa-lg blue"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {selectedPlan.silver && (
                  <div>
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-medal mr-5 fa-lg mt-5 blue"></i>
                        <p className="sub-section blue">ime Silver Package</p>
                      </div>
                    </div>
                    <div
                      className="gift-subs"
                      price={10000}
                      onClick={(e) =>
                        setSelectedPlan({
                          silver: true,
                          gold: false,
                          platinum: false,
                          price: e.currentTarget.attributes.price.value,
                        })
                      }
                    >
                      <div className="job-posts-count white bold">1</div>
                      <div className="gift-subs-description">
                        <div className="gift-subs-icon-text bold">
                          ime Silver Package
                          <i className="fas fa-box-open mx-10 fa-lg align-icon blue"></i>
                        </div>
                      </div>
                      <div className="gift-subs-price blue">
                        <div className="gift-subs-icon-text-center bold">
                          $100
                          <i className="fas fa-ranking-star mx-10 fa-lg blue"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {selectedPlan.silver && (
                  <div className="sub-grid">
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-star mr-5 fa-lg mt-5 blue"></i>
                        <p className="sub-section blue">Benefits</p>
                      </div>
                    </div>
                    <p className="sub-description">
                      ime's Silver Package consists of one (1) job posting for
                      30 days, alongside one (1) Job Live Stream and one (1) VR
                      Tour post. This package is tailored towards employers
                      looking to hire for a small team.
                    </p>
                  </div>
                )}
                {!selectedPlan.silver &&
                  !selectedPlan.gold &&
                  !selectedPlan.platinum && (
                    <div>
                      <div className="sub-section-container">
                        <div className="flex-only">
                          <i className="fas fa-medal mr-5 fa-lg mt-5 blue"></i>
                          <p className="sub-section blue">ime Gold Package</p>
                        </div>
                      </div>
                      <div
                        className="gift-subs"
                        price={30000}
                        onClick={(e) =>
                          setSelectedPlan({
                            silver: false,
                            gold: true,
                            platinum: false,
                            price: e.currentTarget.attributes.price.value,
                          })
                        }
                      >
                        <div className="job-posts-count white bold">50</div>
                        <div className="gift-subs-description">
                          <div className="gift-subs-icon-text bold">
                            ime Gold Package
                            <i className="fas fa-box-open mx-10 fa-lg align-icon blue"></i>
                          </div>
                        </div>
                        <div className="gift-subs-price blue">
                          <div className="gift-subs-icon-text-center bold">
                            $300
                            <i className="fas fa-ranking-star mx-10 fa-lg blue"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {selectedPlan.gold && (
                  <div>
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-medal mr-5 fa-lg mt-5 blue"></i>
                        <p className="sub-section blue">ime Gold Package</p>
                      </div>
                    </div>
                    <div
                      className="gift-subs"
                      price={30000}
                      onClick={(e) =>
                        setSelectedPlan({
                          silver: false,
                          gold: true,
                          platinum: false,
                          price: e.currentTarget.attributes.price.value,
                        })
                      }
                    >
                      <div className="job-posts-count white bold">50</div>
                      <div className="gift-subs-description">
                        <div className="gift-subs-icon-text bold">
                          ime Gold Package
                          <i className="fas fa-box-open mx-10 fa-lg align-icon blue"></i>
                        </div>
                      </div>
                      <div className="gift-subs-price blue">
                        <div className="gift-subs-icon-text-center bold">
                          $300
                          <i className="fas fa-ranking-star mx-10 fa-lg blue"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {selectedPlan.gold && (
                  <div className="sub-grid">
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-star mr-5 fa-lg mt-5 blue"></i>
                        <p className="sub-section blue">Benefits</p>
                      </div>
                    </div>
                    <p className="sub-description">
                      ime's Gold Package provides you with the ability to post
                      up to 50 job postings in a month, expiring 30 days after
                      initial posting. Each job post is parterned with one (1)
                      Job Stream and one (1) VR Tour per post.
                    </p>
                  </div>
                )}
                {!selectedPlan.silver &&
                  !selectedPlan.gold &&
                  !selectedPlan.platinum && (
                    <div>
                      <div className="sub-section-container">
                        <div className="flex-only">
                          <i className="fas fa-medal mr-5 fa-lg mt-5 blue"></i>
                          <p className="sub-section blue">
                            ime Platinum Package
                          </p>
                        </div>
                      </div>
                      <div
                        className="gift-subs"
                        price={50000}
                        onClick={(e) =>
                          setSelectedPlan({
                            silver: false,
                            gold: false,
                            platinum: true,
                            price: e.currentTarget.attributes.price.value,
                          })
                        }
                      >
                        <div className="job-posts-count white bold">75</div>
                        <div className="gift-subs-description">
                          <div className="gift-subs-icon-text bold">
                            ime Platinum Package
                            <i className="fas fa-box-open mx-10 fa-lg align-icon blue"></i>
                          </div>
                        </div>
                        <div className="gift-subs-price blue">
                          <div className="gift-subs-icon-text-center bold">
                            $500
                            <i className="fas fa-ranking-star mx-10 fa-lg blue"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {selectedPlan.platinum && (
                  <div>
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-medal mr-5 fa-lg mt-5 blue"></i>
                        <p className="sub-section blue">ime Platinum Package</p>
                      </div>
                    </div>
                    <div
                      className="gift-subs"
                      price={50000}
                      onClick={(e) =>
                        setSelectedPlan({
                          silver: false,
                          gold: false,
                          platinum: true,
                          price: e.currentTarget.attributes.price.value,
                        })
                      }
                    >
                      <div className="job-posts-count white bold">75</div>
                      <div className="gift-subs-description">
                        <div className="gift-subs-icon-text bold">
                          ime Platinum Package
                          <i className="fas fa-box-open mx-10 fa-lg align-icon blue"></i>
                        </div>
                      </div>
                      <div className="gift-subs-price blue">
                        <div className="gift-subs-icon-text-center bold">
                          $500
                          <i className="fas fa-ranking-star mx-10 fa-lg blue"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {selectedPlan.platinum && (
                  <div className="sub-grid">
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-star mr-5 fa-lg mt-5 blue"></i>
                        <p className="sub-section blue">Benefits</p>
                      </div>
                    </div>
                    <p className="sub-description">
                      Looking to get the most out of your recruiting efforts?
                      ime's Platinum Package is the best fit for you! Post up to
                      75 jobs per month, expiring 30 days after initial posting.
                      These job postings are also paired with one (1) Job Stream
                      and one (1) VR Tour per post. Reach a large audience and
                      explore the many talented and motivated innovators looking
                      to make a difference within your company.The Platinum
                      Package is best tailored for employers looking to hire
                      frequently and for large teams.
                    </p>
                  </div>
                )}
                <div className="billing">
                  <div className="sub-section-container-alt">
                    <div className="flex-only">
                      <p className="sub-section blue">Payment Methods</p>
                    </div>
                    <div className="flex-only">
                      <i className="fab fa-cc-visa mr-5 mt-10 fa-2x white"></i>
                      <i className="fab fa-cc-mastercard mx-5 mt-10 fa-2x white"></i>
                      <i className="fab fa-cc-jcb mx-5 mt-10 fa-2x white"></i>
                      <i className="fab fa-cc-discover mx-5 mt-10 fa-2x white"></i>
                      <i className="fab fa-cc-diners-club mx-5 mt-10 fa-2x white"></i>
                      <i className="fab fa-cc-amex mx-5 mt-10 fa-2x white"></i>
                    </div>
                  </div>
                  <div className="sub-section-container-alt-m">
                    <div className="flex-only">
                      <p className="sub-section blue">Card Information</p>
                    </div>
                  </div>
                  <div className="sub-grid-two">
                    <div className="input-grid">
                      <label htmlFor="name" className="blue bold block">
                        *Name on Card
                      </label>
                      {billingDetails.name === "" && <Alert />}
                      <Field
                        name="name"
                        id="name"
                        type="text"
                        placeholder="Enter Name on Card"
                        required
                        autoComplete="name"
                        value={billingDetails.name}
                        onChange={(e) => {
                          setBillingDetails({
                            ...billingDetails,
                            name: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="input-grid">
                      <label htmlFor="email" className="blue bold block">
                        *Email Address
                      </label>
                      {billingDetails.email === "" && <Alert />}
                      <Field
                        name="email"
                        id="email"
                        type="email"
                        placeholder="Enter Email Address"
                        required
                        autoComplete="email"
                        value={billingDetails.email}
                        onChange={(e) => {
                          setBillingDetails({
                            ...billingDetails,
                            email: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="input-grid">
                      <label htmlFor="cardnumber" className="blue bold block">
                        *Card Number
                      </label>
                      <CardField
                        onChange={(e) => {
                          setError(e.error);
                          setCardComplete(e.complete);
                        }}
                      />
                    </div>
                  </div>
                  <div className="sub-grid-two">
                    <div className="input-grid">
                      <label htmlFor="line1" className="blue bold block">
                        *Billing Address Line 1
                      </label>
                      {billingDetails.address.line1 === "" && <Alert />}
                      <Field
                        name="line1"
                        id="line1"
                        type="text"
                        placeholder="Enter Street Address"
                        required
                        autoComplete="line1"
                        value={billingDetails.address.line1}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.line1 = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      />
                    </div>
                    <div className="input-grid">
                      <label htmlFor="line2" className="blue bold block">
                        Billing Address Line 2
                      </label>
                      <Field
                        name="line2"
                        id="line2"
                        type="text"
                        placeholder="Enter Suite, Apt, Unit"
                        autoComplete="line2"
                        value={billingDetails.address.line2}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.line2 = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      />
                    </div>
                  </div>
                  <div className="sub-grid-three-alt-subscribe">
                    <div className="input-grid">
                      <label htmlFor="country" className="blue bold block">
                        *Country
                      </label>
                      {billingDetails.address.country === "" && <Alert />}
                      <select
                        name="country"
                        id="country"
                        type="country"
                        required
                        value={billingDetails.address.country}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.country = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      >
                        <option value="US">US</option>
                        <option value="AU">AU</option>
                        <option value="AT">AT</option>
                        <option value="BE">BE</option>
                        <option value="BR">BR</option>
                        <option value="BG">BG</option>
                        <option value="CA">CA</option>
                        <option value="CY">CY</option>
                        <option value="CZ">CZ</option>
                        <option value="DK">DK</option>
                        <option value="EE">EE</option>
                        <option value="FI">FI</option>
                        <option value="FR">FR</option>
                        <option value="DE">DE</option>
                        <option value="GR">GR</option>
                        <option value="HK">HK</option>
                        <option value="HU">HU</option>
                        <option value="IN">IN</option>
                        <option value="IE">IE</option>
                        <option value="IT">IT</option>
                        <option value="JP">JP</option>
                        <option value="LV">LV</option>
                        <option value="LT">LT</option>
                        <option value="LU">LU</option>
                        <option value="MY">MY</option>
                        <option value="MT">MT</option>
                        <option value="MX">MX</option>
                        <option value="NL">NL</option>
                        <option value="NZ">NZ</option>
                        <option value="NO">NO</option>
                        <option value="PL">PL</option>
                        <option value="PT">PT</option>
                        <option value="RO">RO</option>
                        <option value="SG">SG</option>
                        <option value="SK">SK</option>
                        <option value="SI">SI</option>
                        <option value="ES">ES</option>
                        <option value="SE">SE</option>
                        <option value="CH">CH</option>
                        <option value="AE">AE</option>
                        <option value="GB">GB</option>
                      </select>
                    </div>
                    {billingDetails.address.country === "US" && (
                      <div className="input-grid">
                        <label htmlFor="state" className="blue bold block">
                          *State
                        </label>
                        {billingDetails.address.state === "" && <Alert />}
                        <select
                          name="state"
                          id="state"
                          type="state"
                          required
                          value={billingDetails.address.state}
                          onChange={(e) => {
                            const billingdetails = { ...billingDetails };
                            billingdetails.address.state = e.target.value;
                            setBillingDetails(billingdetails);
                          }}
                        >
                          <option value="Alabama">Alabama</option>
                          <option value="Alaska">Alaska</option>
                          <option value="Arizona">Arizona</option>
                          <option value="Arkansas">Arkansas</option>
                          <option value="California">California</option>
                          <option value="Colorado">Colorado</option>
                          <option value="Connecticut">Connecticut</option>
                          <option value="Delaware">Delaware</option>
                          <option value="Florida">Florida</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Hawaii">Hawaii</option>
                          <option value="Idaho">Idaho</option>
                          <option value="Illinois">Illinois</option>
                          <option value="Indiana">Indiana</option>
                          <option value="Iowa">Iowa</option>
                          <option value="Kansas">Kansas</option>
                          <option value="Kentucky">Kentucky</option>
                          <option value="Louisiana">Louisiana</option>
                          <option value="Maine">Maine</option>
                          <option value="Maryland">Maryland</option>
                          <option value="Massachusetts">Massachusetts</option>
                          <option value="Michigan">Michigan</option>
                          <option value="Minnesota">Minnesota</option>
                          <option value="Mississippi">Mississippi</option>
                          <option value="Missouri">Missouri</option>
                          <option value="Montana">Montana</option>
                          <option value="Nebraska">Nebraska</option>
                          <option value="Nevada">Nevada</option>
                          <option value="New Hampshire">New Hampshire</option>
                          <option value="New Jersey">New Jersey</option>
                          <option value="New Mexico">New Mexico</option>
                          <option value="New York">New York</option>
                          <option value="North Carolina">North Carolina</option>
                          <option value="North Dakota">North Dakota</option>
                          <option value="Ohio">Ohio</option>
                          <option value="Oklahoma">Oklahoma</option>
                          <option value="Oregon">Oregon</option>
                          <option value="Pennsylvania">Pennsylvania</option>
                          <option value="Rhode Island">Rhode Island</option>
                          <option value="South Carolina">South Carolina</option>
                          <option value="South Dakota">South Dakota</option>
                          <option value="Tennessee">Tennessee</option>
                          <option value="Texas">Texas</option>
                          <option value="Utah">Utah</option>
                          <option value="Vermont">Vermont</option>
                          <option value="Virginia">Virginia</option>
                          <option value="Washington">Washington</option>
                          <option value="West Virginia">West Virginia</option>
                          <option value="Wisconsin">Wisconsin</option>
                          <option value="Wyoming">Wyoming</option>
                        </select>
                      </div>
                    )}
                    {billingDetails.address.country !== "US" && (
                      <div className="input-grid">
                        <label htmlFor="state" className="blue bold block">
                          *State
                        </label>
                        {billingDetails.address.state === "" && <Alert />}
                        <Field
                          name="state"
                          id="state"
                          type="state"
                          placeholder="Enter State"
                          required
                          autoComplete="state"
                          value={billingDetails.address.state}
                          onChange={(e) => {
                            setBillingDetails({
                              ...billingDetails,
                              address: { state: e.target.value },
                            });
                          }}
                        />
                      </div>
                    )}
                    <div className="input-grid">
                      <label htmlFor="city" className="blue bold block">
                        *City
                      </label>
                      {billingDetails.address.city === "" && <Alert />}
                      <Field
                        name="city"
                        id="city"
                        type="text"
                        placeholder="Enter City"
                        autoComplete="city"
                        required
                        value={billingDetails.address.city}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.city = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      />
                    </div>
                  </div>
                  <div className="checkboxes">
                    <input
                      className="mx-5 checkbox"
                      type="checkbox"
                      checked={isCheckedAutoRenew}
                      onChange={(e) => setIsCheckedAutoRenew(e.target.checked)}
                    ></input>
                    <span className="blue bold mx-5">
                      Auto renew subscription
                    </span>
                  </div>
                  {error && <ErrorMessage>{error.message}</ErrorMessage>}
                  {selectedPlan.price > 0 && (
                    <SubmitButton
                      method="POST"
                      processing={processing}
                      error={error}
                      disabled={!stripe}
                      onSubmit={(e) =>
                        foundSubscription && foundSubscription.length > 0
                          ? handleResubscribe(e)
                          : handleSubmit(e)
                      }
                    >
                      <i className="fas fa-user-check mr-5"></i>Confirm and
                      Subscribe
                    </SubmitButton>
                  )}
                </div>
              </form>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

SubscribeIMEEmployer.propTypes = {
  auth: PropTypes.object.isRequired,
  getSubscriptions: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscribe: state.subscribe,
});

export default connect(mapStateToProps, {
  getSubscriptions,
})(SubscribeIMEEmployer);
